import { Component, effect, ElementRef, input, viewChild } from '@angular/core';
import QRCodeStyling from 'qr-code-styling';

@Component({
  selector: 'app-qr-code',
  template: `<div
    [title]="alt()"
    class="bg-white dark:bg-surface-100 rounded-lg overflow-hidden"
    #qrContainer></div>`,
  standalone: true,
})
export class QrCodeComponent {
  qrContainer = viewChild<ElementRef<HTMLDivElement>>('qrContainer');
  private _qrCode: QRCodeStyling | null = null;
  url = input.required<string>();
  alt = input<string>('');
  width = input<number>(300);
  height = input<number>(300);

  constructor() {
    this._qrCode = null;

    effect(() => {
      const container = this.qrContainer();
      const url = this.url();
      const width = this.width();
      const height = this.height();
      if (container && url) {
        this.renderQrCode(container.nativeElement, url, width, height);
      }
    });
  }

  private renderQrCode(
    container: HTMLElement,
    url: string,
    width: number,
    height: number,
  ): void {
    if (this._qrCode) {
      this._qrCode.update({ data: url, width, height });
    } else {
      this._qrCode = new QRCodeStyling({
        width,
        height,
        data: url,
        margin: 0,
        qrOptions: {
          errorCorrectionLevel: 'H',
        },
        image: 'assets/logo-icon-only.svg',
        imageOptions: {
          imageSize: 0.4,
          margin: 4,
          hideBackgroundDots: true,
        },
        dotsOptions: {
          type: 'dots',
          color: '#1b144b',
        },
        cornersSquareOptions: {
          type: 'extra-rounded',
          color: '#1b144b',
        },
        cornersDotOptions: {
          type: 'dot',
          color: '#1b144b',
        },
        backgroundOptions: {
          color: 'transparent',
        },
      });
      this._qrCode.append(container);
    }
  }
}
